import $ from 'jquery';

/**
 * Ajax Pagination
 */

export default () => {

  $(document).ready(function() {
        
    $('.webinars-list').on('click','.pagination a.page-numbers',function(e) {
        
        e.preventDefault();

        var link = jQuery(this).attr('href');
        
        var prjContainer = '#' + $(this).closest('.webinars-list').attr('id');

        var paged = link.replace(/\/$/, '').split('/').pop();
        var cPage = $(this).closest('.webinars-list').attr('data-page');
        var ltWrs = $(this).closest('.webinars-list').attr('data-latest');
                
        $.ajax({
              url : wg_ajax_url.ajaxurl, 
              method : 'post',
              data : {
                  action : 'webinars_fetch', 
                  paged : paged,
                  cPage : cPage,
                  ltWrs : ltWrs,
              },
              beforeSend : function ( xhr ) {
                    $(prjContainer).addClass('preload'); //preloader
                },
              success : function( response ) {
                $(prjContainer).empty();
                $(prjContainer).append(response);
                $(prjContainer).removeClass('preload');
                //$('body').scrollTo( prjContainer );
                $('html,body').animate({
                    scrollTop: $(prjContainer).offset().top - 200
                }, 1000);
              },
              error : function () {
                $("Problem").appendTo(prjContainer);
              }
          });

            // $('#cservices').change(function() {
            //     var $service_main = $(this).val();
            //     // call ajax
            //     $("#cservices_type").empty();
            //     $("#cservices_type").append("<option>Loading...</option");
            //     $.ajax({
            //       url: cccAjx.ccc_url,
            //       type: 'POST',
            //       data: 'action=load_sub_cats&service_main=' + $service_main,
            
            //       success: function(results) {
            //         //  alert(results);
            //         $("#cservices_type").removeAttr("disabled");
            //         $("#cservices_type").empty();
            //         $("#cservices_type").append(results);
            //       }
            //     });
            //   });

    });
});
  
};
